module.exports = __webpack_public_path__ + "img/slide5.7f1aa409.png";